import type Phaser from 'phaser';

let soundManager: Phaser.Sound.BaseSoundManager | null = null;
let globalVolume = 1;
let muted = false;

export function init(scene: Phaser.Scene): void {
  soundManager = (scene as any).sound as Phaser.Sound.BaseSoundManager;
}

export function setMuted(enabled: boolean): void {
  muted = !enabled;
  if (soundManager) {
    (soundManager as any).mute = muted;
  }
}

export function setVolume(value: number): void {
  globalVolume = value;
  if (soundManager && typeof (soundManager as any).setVolume === 'function') {
    try {
      (soundManager as any).setVolume(globalVolume);
    } catch {
      // ignore
    }
  }
}

export function playSFX(key: string, opts?: { volume?: number }): void {
  if (!soundManager) return;
  const vol = (opts?.volume ?? 1) * globalVolume;
  try {
    const s = soundManager.get(key) as Phaser.Sound.BaseSound | undefined;
    if (s) {
      s.play({ volume: vol });
    } else {
      // Try playing by key
      (soundManager as any).play(key, { volume: vol });
    }
  } catch {
    // If audio can't be played, silently ignore (headless/test env)
  }
}

export function playBGM(key: string, opts?: { loop?: boolean; volume?: number }): void {
  if (!soundManager) return;
  try {
    const s = soundManager.get(key) as Phaser.Sound.BaseSound | undefined;
    if (s) {
      s.play({ loop: !!opts?.loop, volume: (opts?.volume ?? 1) * globalVolume });
    } else {
      (soundManager as any).play(key, { loop: !!opts?.loop, volume: (opts?.volume ?? 1) * globalVolume });
    }
  } catch {
    // ignore
  }
}
